<template>
  <div class="carousel-container position-relative" @mouseenter="pauseAutoSlide" @mouseleave="startAutoSlide">
    <!-- Cards Wrapper -->
    <div class="d-flex transition-all" :style="carouselStyle">
      <div v-for="(card, index) in displayCards" :key="index" class="carousel-card text-center p-3">
        <div class="profile-card shadow-lg">
          <img :src="card.image || dummyImage" class="profile-img" />
          <h5 class="mt-3 mb-1">{{ card.namaKaryawan || "Employee" }}</h5>
          <p class="role">{{ card.namaPosisi || "Worker" }}</p>
          <p class="role">{{ card.total || "0" }} Points</p>
          <button @click="$emit('clicked', card)" :class="['btn', `btn-${buttonColor}`, 'btn-sm', 'mt-2']">{{ button }}</button>
        </div>
      </div>
    </div>

    <!-- Prev Button -->
    <button v-if="hover" class="carousel-btn left" @click="prev">‹</button>

    <!-- Next Button -->
    <button v-if="hover" class="carousel-btn right" @click="next">›</button>

    <!-- Indicators -->
    <div class="d-flex justify-content-center mt-3">
      <span v-for="(dot, i) in totalSlides" :key="i" class="dot" :class="{ active: i === Math.floor(currentIndex / perPage) }" @click="goToSlide(i)"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardCarousel",
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    interval: {
      type: Number,
      default: 5000,
    },
    button: {
      type: String,
      default: "Button",
    },
    buttonColor: {
      type: String,
      default: "primary",
    },
  },
  data() {
    return {
      currentIndex: 0,
      timer: null,
      hover: false,
      perPage: 1,
      dummyImage: "https://picsum.photos/200/300",
    };
  },
  computed: {
    displayCards() {
      // duplicate so we can loop infinitely
      return this.cards.length
        ? [...this.cards]
        : Array(3)
            .fill()
            .map(() => ({
              image: this.dummyImage,
              name: "Jane Doe",
              title: "UI/UX Designer",
            }));
    },
    carouselStyle() {
      return {
        width: this.displayCards.length * (100 / this.perPage) + "%",
        transform: `translateX(-${this.currentIndex * (100 / this.displayCards.length)}%)`,
        transition: "transform 0.6s ease",
      };
    },
    totalSlides() {
      return 3;
    },
  },
  methods: {
    next() {
      if (this.currentIndex >= this.displayCards.length - this.perPage) {
        this.currentIndex = 0; // reset smoothly
      } else {
        this.currentIndex++;
      }
    },
    prev() {
      if (this.currentIndex <= 0) {
        this.currentIndex = this.displayCards.length - this.perPage;
      } else {
        this.currentIndex--;
      }
    },
    goToSlide(i) {
      this.currentIndex = i * this.perPage;
    },
    startAutoSlide() {
      this.timer = setInterval(this.next, 5000); // smoother timing
      this.hover = false;
    },
    pauseAutoSlide() {
      clearInterval(this.timer);
      this.hover = true;
    },
  },
  mounted() {
    this.startAutoSlide();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.carousel-container {
  width: 100%;
  max-width: 1200px;
  margin: auto;
  overflow: hidden;
  position: relative;
  background: #0d1126;
  padding: 20px 20px;
  border-radius: 20px;
}

/* Show 3 cards */
.carousel-card {
  flex: 0 0 calc(100% / 3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(6px);
  border-radius: 15px;
  padding: 25px 20px;
  text-align: center;
  transition: transform 0.3s ease;
  color: #fff;
  min-height: 100px;
  width: 90%;
}

.profile-card:hover {
  transform: scale(1.05);
}

.profile-img {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  border: 3px solid #fff;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.profile-img:hover {
  transform: scale(1.2);
}

.role {
  color: #ccc;
  font-size: 14px;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  color: #000;
  border: none;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  transition: background 0.3s ease;
  z-index: 10;
}

.carousel-btn:hover {
  background: #007bff;
  color: #fff;
}

.carousel-btn.left {
  left: 20px;
}

.carousel-btn.right {
  right: 20px;
}

.dot {
  height: 10px;
  width: 10px;
  margin: 0 5px;
  background-color: #666;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  transition: background 0.3s ease;
}

.dot.active {
  background-color: #007bff;
}

/* Gradient background circles */
.carousel-container::before,
.carousel-container::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.6;
}

.carousel-container::before {
  width: 250px;
  height: 250px;
  background: #ff4081;
  top: -50px;
  left: -50px;
}

.carousel-container::after {
  width: 250px;
  height: 250px;
  background: #2979ff;
  bottom: -50px;
  right: -50px;
}
</style>
